import constants from 'constants/index'

import * as yup from 'yup'

const { STORAGE_DEFINED_TYPE, STORAGE_UNDEFINED_TYPE } = constants.dataProcess

const dataLifeCycleSchema = ({ hasNewAssetInventory }) =>
  yup.object().shape({
    dataLifeCycleId: yup.string(),
    retentionFinality: yup.string().required(),
    internalAllocationModeId: yup.string().required(),
    assetInventory: yup
      .object()
      .shape({
        id: yup.number(),
        name: yup.string(),
      })
      .nullable()
      .typeError('Preencha esse campo'),
    assetInventoryCategory: yup
      .object()
      .shape({
        id: yup.number(),
        name: yup.string(),
      })
      .when([], {
        is: () => !hasNewAssetInventory,
        then: (schema) => schema.required().typeError('Preencha esse campo'),
        otherwise: (schema) => schema.nullable().notRequired(),
      }),
    protectionId: yup.string().required(),
    recoveryId: yup.string().required(),
    storageType: yup.number().typeError('Preencha esse campo').required(),
    discardModeId: yup.string().when(['storageType'], {
      is: (storageType) =>
        storageType === STORAGE_DEFINED_TYPE ||
        storageType === STORAGE_UNDEFINED_TYPE,
      then: yup.string().required(),
    }),
    value: yup.number().when('storageType', {
      is: STORAGE_DEFINED_TYPE,
      then: yup.number().typeError('Precisa ser um número').required(),
    }),
    volumetry: yup.string().when('storageType', {
      is: STORAGE_DEFINED_TYPE,
      then: yup.string().required(),
    }),
    anotherAssetInventory: yup
      .string()
      .max(255)
      .when([], {
        is: () => hasNewAssetInventory,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired(),
      }),
    anotherDiscardMode: yup.string().when('discardModeId', {
      is: 'another',
      then: yup.string().required(),
    }),
    anotherRecovery: yup.string().when('recoveryId', {
      is: 'another',
      then: yup.string().required(),
    }),
  })

export default dataLifeCycleSchema
